module.exports = require("./createClass.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/create-class.js
 ** module id = 277
 ** module chunks = 1
 **/